import moment from 'moment';
import React, { useState } from 'react'
import Swal from 'sweetalert2';
import { utcToLocalTime } from '../../../../../Studio-Services/Studio_Services';

export default function ParentActivePurchasedPasses({
    studioData, logo, changeStatus, changeExPassInfo,
    purchaseRecurringPass, purchaseTimeFramePass, purchasePunchCardPassRecurring,
    purchasePunchCardPass, changePassInfo, checkCardExpire, setPunchConfirmShow
}) {

    const recurringPass = Array.isArray(purchaseRecurringPass) ? purchaseRecurringPass : [];
    const timeFramePass = Array.isArray(purchaseTimeFramePass) ? purchaseTimeFramePass : [];
    const punchCardPassRecurring = Array.isArray(purchasePunchCardPassRecurring) ? purchasePunchCardPassRecurring : [];
    const punchCardPass = Array.isArray(purchasePunchCardPass) ? purchasePunchCardPass : [];

    return (
        <>
            <h4 className="title text-capitalize mt-5">Active Purchased Passes</h4>
            <h4 className="group_card mt-3">Recurring Membership</h4>
            {recurringPass.length > 0 &&
                <div className="row pt-4 mb-3">
                    {recurringPass.map((lists) => (
                        <div className="col-md-6 col-xl-4">
                            <div className="prelist-pass p-3 blueback-passes mb-3">
                                <div className="mx-0 row align-items-center">
                                    <div className="col-md-9">
                                        <div className="passdetail_new flex-fill">
                                            <p className="mb-0 text-capitalize">{lists.pass_name}</p>
                                            <h6 className="mb-2"> $ {lists.full_price} <small>Plus Tax</small></h6>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="passnew_logo">
                                            <img src={studioData && studioData.business_img} className="img-fluid" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-4">
                                    <div className="col-8">
                                        <p>Auto Renew</p>

                                        {lists.pass_cancellation_date == '' && lists.pass_pause_start_less_then_thirty == '' &&
                                            <p style={{ textTransform: 'capitalize' }}>Status:  {lists.card_status}</p>}
                                        {lists.pass_cancellation_date != '' && lists.pass_pause_start_less_then_thirty == '' &&
                                            <p>Status: Cancelled</p>}
                                        {lists.pass_pause_start_less_then_thirty != '' &&
                                            <p >Status: Paused</p>}
                                        {lists.pass_pause_start_less_then_thirty != '' && lists.is_recurring_stop != 0 &&
                                            <p >Paused :  {moment(lists.pass_pause_start_less_then_thirty).format(" MMMM DD, YYYY")}</p>}
                                        {lists.pass_pause_end_less_then_thirty != '' && lists.is_recurring_stop != 0 &&
                                            <p>Restart Date: {moment(lists.pass_pause_end_less_then_thirty).format(" MMMM DD, YYYY")}</p>}
                                    </div>
                                    <div className="col-4">
                                        {lists.passes_status == 1 && lists.pass_cancellation_date == '' && lists.card_status == 'active' &&
                                            <button className="btn btn-brandgreengrad text-center" style={{ height: '35px' }}
                                                onClick={() => { changeStatus(1, lists.booking_pass_id, lists.pass_id, lists); }}

                                            >Active
                                            </button>}
                                        {lists.is_recurring_stop == 1 && lists.pass_cancellation_date == '' && lists.card_status == 'paused' &&
                                            <button className="btn btn-brandyellows text-right" style={{ background: '#fafa00', height: '35px' }} onClick={() => changeStatus(0, lists.booking_pass_id, lists.pass_id, lists)}
                                            >
                                                Paused
                                            </button>
                                        }

                                        {lists.pass_cancellation_date != '' && lists.pass_pause_start_less_then_thirty == '' &&
                                            <button className="btn btn-brandyellowcancel text-right" onClick={() => {
                                                Swal.fire({
                                                    html: `
                                                        <img src=${logo} class="img-fluid d-block mx-auto mt-5" />
                                                        <h4 class="title text-capitalize text-center mt-4 textWhite">Notice</h4>
                                                        <p class="text-center my-4 textcolor">
                                                            <small class="textWhite">Passes that are cancelled are not allowed to be reactivated.
                                                            You can let the client purchase a new pass when it expires.   Or purchase it for them using a card on file. 
                                                            </small>
                                                        </p>
                                                        `,
                                                    showClass: {
                                                        popup: 'custom-dialog-container',
                                                    },
                                                    customClass: {
                                                        confirmButton: 'custom-button custom-button-size modalbtn',
                                                    },
                                                    confirmButtonText: 'OK',
                                                })

                                            }}
                                                style={{ marginLeft: "-5px" }}>
                                                Cancelling
                                            </button>}
                                    </div>
                                    <div col-md-12>
                                        <p>Start Date :  {utcToLocalTime(lists.start_date_utc)}</p>
                                        {["33", "34", "35", "36"].includes(lists.pass_type_subcat) && lists?.pass_renewal_date && (
                                            <p>Renewal Date : {lists?.pass_cancellation_date ? "Stopped" : moment(lists.pass_renewal_date).format(" MMMM DD, YYYY")}</p>
                                        )}


                                        {["33", "34", "35", "36"].includes(lists.pass_type_subcat) ? (
                                            <p> Expiry Date : {moment(lists.pass_final_end_date).format(" MMMM DD, YYYY")}</p>
                                        ) : (
                                            lists.pass_cancellation_date == '' && lists.passes_status == 1 &&
                                            <p>Expiry Date: {moment.unix(lists.pass_expired_date).format(" MMMM DD, YYYY")}
                                                <button type="button" className="fa fa-edit" data-toggle="modal" data-target="#passInfoExpireDateModel"
                                                    onClick={() => changeExPassInfo(lists)}
                                                ></button>
                                            </p>
                                        )}

                                        {["33"].includes(lists.pass_type_subcat) && (<p> Valid for 90 Days</p>)}
                                        {["34"].includes(lists.pass_type_subcat) && (<p> Valid for 180 Days</p>)}
                                        {["35"].includes(lists.pass_type_subcat) && (<p> Valid for 360 Days</p>)}

                                    </div>
                                </div>
                                <div className="row mt-1 align-items-end">
                                    <div className="col-8">
                                    </div>
                                    <div className="col-4">
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            }
            {recurringPass.length == 0 && <div> <p className="text-center">No Records Found</p> </div>}


            <h4 className="group_card mt-3">Time Frame</h4>
            {timeFramePass.length < 3 &&
                <div className="row pt-4">
                    {timeFramePass.map((lists) => (
                        <div className="col-md-6 col-lg-4">
                            <div className="prelist-pass p-3 blueback-passes">
                                <div className="mx-0 row align-items-center">

                                    <div className="col-md-9">
                                        <div className="passdetail_new flex-fill">
                                            <p className="mb-0 text-capitalize">{lists.pass_name}</p>
                                            <h6 className="mb-2"> $ {lists.amount} <small>Plus Tax</small></h6>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="passnew_logo">
                                            <img src={studioData && studioData.business_img} alt="" className="img-fluid" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-4">
                                </div>
                                <div className="row mt-1 align-items-end">
                                    <div className="col-12">
                                        <p className="font-12">Start Date :
                                            {utcToLocalTime(lists.start_date_utc)} </p>
                                    </div>
                                </div>
                                <div className="row mt-1 align-items-end">
                                    <div className="col-12">
                                        <p className="font-12">Expiration Date :
                                            {moment.unix(lists.end_date_utc).format(" MMMM DD, YYYY")} <button type="button"
                                                className="fa fa-edit" data-toggle="modal"
                                                data-target="#passInfoModel"
                                                onClick={() => changePassInfo(lists)}
                                            ></button></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            }
            {timeFramePass.length == 0 && <div  > <p className="text-center">No Records Found</p>  </div>}

            <h4 className="group_card mt-3">Punch Card</h4>
            {punchCardPass.length > 0 &&
                <div className="row pt-4" >
                    {punchCardPass.map((lists) => (
                        <div className="col-md-6 col-lg-4">
                            <div className="prelist-pass p-3 blueback-passes">
                                <div className="mx-0 row align-items-center">

                                    <div className="col-md-9">
                                        <div className="passdetail_new flex-fill">
                                            <p className="mb-0 text-capitalize">{lists.pass_name}</p>
                                            <h6 className="mb-2"> $ {lists.amount} <small>Plus Tax</small></h6>
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="passnew_logo">
                                            <img src={studioData && studioData.business_img} alt="" className="img-fluid" />
                                        </div>
                                    </div>

                                </div>
                                <div className="row mt-4">
                                    <div className="col-md-12">
                                        <p>Remaining Classes : {lists.passes_remaining_count} of {lists.passes_total_count}
                                            <button type="button" data-toggle="modal"
                                                data-target="#passInfoModel" className="fa fa-edit"
                                                onClick={() => { checkCardExpire(lists?.end_date_utc) && changePassInfo(lists) }}
                                            ></button>
                                        </p>
                                    </div>
                                </div>
                                <div className="row mt-1 align-items-end">
                                    <div className="col-md-12">
                                        <p className="font-12">Start Date :
                                            {utcToLocalTime(lists.start_date_utc)} </p>
                                    </div>
                                </div>
                                <div className="row mt-1 align-items-end">
                                    <div className="col-md-12">
                                        <p className="font-12">Expiration Date :
                                            {moment.unix(lists.end_date_utc).format(" MMMM DD, YYYY")}
                                            <button type="button" data-toggle="modal"
                                                data-target="#passInfoDateModel" className="fa fa-edit"
                                                onClick={() => changePassInfo(lists, 2)}
                                            ></button>

                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            }
            {punchCardPass.length == 0 && <div> <p className="text-center">No Records Found</p> </div>}


            <h4 className="group_card mt-3">Recurring Punch Card</h4>
            {punchCardPassRecurring.length > 0 &&
                <div className="row pt-4" >
                    {punchCardPassRecurring.map((lists) => (
                        <div className="col-md-6 col-lg-4 mt-3">
                            <div className="prelist-pass p-3 blueback-passes">
                                <div className="mx-0 row align-items-center">
                                    <div className="col-md-8">
                                        <div className="passdetail_new flex-fill">
                                            <p className="mb-0 text-capitalize">{lists.pass_name}</p>
                                            <h6 className="mb-2"> $ {lists.amount} <small>Plus Tax</small></h6>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="row">

                                            <div className="passnew_logo">
                                                <img src={studioData && studioData.business_img} alt="" className="img-fluid" />
                                            </div>

                                        </div>
                                        <div className="row mt-2">
                                            {lists?.pass_cancellation_date ?
                                                <button className="btn btn-brandyellowcancel text-center"
                                                    onClick={() => {
                                                        Swal.fire({
                                                            html: `
                                                            <img src=${logo} class="img-fluid d-block mx-auto mt-5" />
                                                            <h4 class="title text-capitalize text-center mt-4 textWhite">Notice</h4>
                                                            <p class="text-center my-4 textcolor">
                                                                <small class="textWhite">Passes that are cancelled are not allowed to be reactivated.
                                                                You can let the client purchase a new pass when it expires.   Or purchase it for them using a card on file. 
                                                                </small>
                                                            </p>
                                                            `,
                                                            showClass: {
                                                                popup: 'custom-dialog-container',
                                                            },
                                                            customClass: {
                                                                confirmButton: 'custom-button custom-button-size modalbtn',
                                                            },
                                                            confirmButtonText: 'OK',
                                                        })
                                                    }}
                                                    style={{ marginLeft: "-5px" }}>Cancelling
                                                </button>
                                                : lists?.is_recurring_stop === '0' &&
                                                <button className="btn btn-brandgreengrad text-center" style={{ height: '35px' }}
                                                    onClick={() => {
                                                        setPunchConfirmShow((pre) => ({ ...pre, status: true, data: lists }));
                                                    }}
                                                >Active
                                                </button>
                                            }
                                        </div>
                                    </div>

                                </div>
                                <div className="row mt-4">
                                    <div className="col-md-12">
                                        <p>Remaining Classes : {lists.passes_remaining_count} of {lists.total_count}
                                            <button type="button" data-toggle="modal"
                                                data-target="#passInfoModel" className="fa fa-edit"
                                                onClick={() => { checkCardExpire(lists?.end_date_utc) && changePassInfo(lists); }}
                                            ></button>
                                        </p>
                                    </div>
                                </div>
                                <div className="row mt-1 align-items-end">
                                    <div className="col-md-12">
                                        <p className="font-12">Start Date :
                                            {utcToLocalTime(lists.start_date_utc)} </p>
                                    </div>
                                </div>

                                {lists?.is_recurring_billing == "yes" && (
                                    <p>Renewal Date : {lists?.pass_cancellation_date ? "Stopped" : moment(lists.pass_renewal_date).format(" MMMM DD, YYYY")}</p>
                                )}

                                <div className="row mt-1 align-items-end">
                                    <div className="col-md-12">
                                        <p className="font-12">Expiration Date :
                                            {moment.unix(lists.pass_expired_date).format(" MMMM DD, YYYY")}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            }
            {punchCardPassRecurring.length == 0 && <div> <p className="text-center">No Records Found</p> </div>}
        </ >
    )
}
